import { render, staticRenderFns } from "./EditGroupUser.vue?vue&type=template&id=3531eadd&"
import script from "./EditGroupUser.vue?vue&type=script&lang=js&"
export * from "./EditGroupUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports